import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isNumeric,
  createCustomPropType,
} from '../../../js/app/react/validators';

class ValidationError extends Component {
  constructor(props) {
    super(props);
    this.onMeasureElementReady = this.onMeasureElementReady.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.state = {
      height: null,
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState === this.state) {
      if (this.measureElement) {
        this.onMeasureElementReady(this.measureElement);
      }
    }
  }
  onMeasureElementReady(measureElement) {
    this.measureElement = measureElement;
    let stateSet = false;
    const { ADV } = window;
    if (measureElement) {
      const height = parseFloat(ADV.util.getCss(measureElement, 'height'));
      if (isNumeric(height)) {
        this.setState({
          height,
        });
        stateSet = true;
      }
    }

    if (!stateSet) {
      this.setState({
        height: null,
      });
    }
  }
  getStyle(open) {
    if (open) {
      if (isNumeric(this.state.height)) {
        return {
          marginBottom: '12px',
          height: `${this.state.height}px`,
        };
      }
    }
    return {};
  }
  render() {
    const {
      hasErrors,
      errors,
      clientId,
      close,
    } = this.props;

    return (
      <div>
        <div className="ErrorBubbleContainer" style={this.getStyle(hasErrors)}>
          <div className="ErrorBubble">
            <div className="icon">
              <i className="fa fa-exclamation" />
            </div>

            <ul>
              {errors.map(error => <li key={error}>{error}</li>)}
            </ul>
            <i
              className="fa fa-times close"
              role="button"
              onKeyDown={() => { }}
              tabIndex="0"
              onClick={close(clientId)}
            />
          </div>
        </div>
        {hasErrors && (
          <div className="ErrorBubbleContainer measure-height" ref={this.onMeasureElementReady}>
            <div className="ErrorBubble">
              <div className="icon">
                <i className="fa fa-exclamation" />
              </div>

              <ul>
                {errors.map(error => <li key={error}>{error}</li>)}
              </ul>
              <i
                className="fa fa-times close"
                role="button"
                onKeyDown={() => { }}
                tabIndex="0"
                onClick={close(clientId)}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

ValidationError.defaultProps = {
  errors: [],
};

ValidationError.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  errors: PropTypes.arrayOf(PropTypes.string.isRequired),
  hasErrors: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

export default ValidationError;

